import { Component, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { ReadyProductService } from '../../../../Services/Ready-Product/ready-product.service';
import { HttpParams } from '@angular/common/http';
import { NotificationService } from '../../../../Services/notification.service';
import { Router, RouterLink } from '@angular/router';
import { inject } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Import FormsModule
import autoTable from 'jspdf-autotable'; // For PDF export
import * as XLSX from 'xlsx'; // For Excel export
import jsPDF from 'jspdf'; // For PDF export
import FileSaver from 'file-saver'; // For file saving
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { Subscription } from 'rxjs';
import { StockInService } from '../../../../Services/Stock_Transactions/Stock_in/stock-in.service';

@Component({
  selector: 'app-ready-product-lot-list',
  imports: [NgFor, RouterLink, FormsModule, NgIf],
  templateUrl: './ready-product-lot-list.component.html',
  styleUrl: './ready-product-lot-list.component.css'
})
export class ReadyProductLotListComponent implements OnInit {
  paginatedStockList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  readyProductList: any[] = []; // Initialize as an empty array
  selectedProductType: 'all' | 'piece-wise' | 'lot-wise' = 'all';
  startDate: string = '';
  endDate: string = '';
  filteredReadyProductList: any[] = [];
  activeTab: 'current' | 'history' = 'current';
  stockInHistoryList: any[] = [];
  filteredHistoryList: any[] = [];
  paginatedHistoryList: any[] = [];


  // New properties for filtering, sorting, and column selection
  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  showDropdown: boolean = false;
  globalSearchText: string = '';
  // Define the default set of fields for ready products
  defaultFields = [
    { key: 'rproduct_categories', label: 'Category', selected: true },
    { key: 'rproduct_code', label: 'Product_code', selected: true },
    { key: 'rproduct_supplier_name', label: 'Supplier Name', selected: true },
    { key: 'rproduct_silver_rate_per_gm', label: 'Silver Rate/GM', selected: true },
    { key: 'rproduct_per_gram_labour', label: 'Per Gram Labour', selected: true },
    { key: 'rproduct_shipping_per_gm', label: 'Shipping/GM', selected: true },
    { key: 'rproduct_other_expense_per_gm', label: 'Other Expense/GM', selected: true },
    { key: 'rproduct__per_gm_cost', label: 'Per GM Cost', selected: true },
    { key: 'rproduct_cny_labour', label: 'CNY Labour', selected: true },
    { key: 'rproduct_total_wt', label: 'Gross Weight', selected: true },
    { key: 'rproduct_total_panni_weight', label: 'Silver Purity in %', selected: true },
    { key: 'rproduct_net_weight', label: 'Fine Weight', selected: true },
    { key: 'rproduct_unit', label: 'Unit', selected: true },
    { key: 'rproduct_date', label: 'Date', selected: true },
  ];

  historyDefaultFields = [
    { key: 'stin_item_code', label: 'Item Code', selected: true },
    { key: 'st_item_category', label: 'Category', selected: true },
    { key: 'stin_total_wt', label: 'Gross Weight', selected: true },
    { key: 'stin_panni_wt', label: 'Silver Purity in %', selected: true },
    { key: 'stin_net_weight', label: 'Fine Weight', selected: true },
    { key: 'stin_entry_date', label: 'Entry Date', selected: true },
    // { key: 'stin_supplier_name', label: 'Supplier Name', selected: true },
  ];

  historySelectedFields: any[] = [];

  selectedFields: any[] = [];
  titleTag: boolean = true;
  firmSubscription!: Subscription;

  constructor(
    private readyProductService: ReadyProductService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private stockInService: StockInService
  ) { }

  router = inject(Router);

  ngOnInit(): void {
    this.loadSelectedFields();
    this.hideTitle();

    // ✅ Subscribe to firm change reactively
    this.firmSubscription = this.firmSelectionService.selectedFirmName$.subscribe((firm) => {
      if (firm && firm.id) {
        // Firm changed → reload data
        this.getReadyProductList();
        this.getLotAdditionHistory();
      } else {
        // No firm selected
        this.readyProductList = [];
        this.paginatedStockList = [];
        this.stockInHistoryList = [];
        this.paginatedHistoryList = [];
      }
    });
  }

  hideTitle() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('report')) {
      this.titleTag = false;
    }
  }

  loadSelectedFields() {
    const readyProductSelection = localStorage.getItem('readyProductSelected');
    if (readyProductSelection) {
      const storedFields = JSON.parse(readyProductSelection);
      const storedFieldMap = new Map(storedFields.map((field: any) => [field.key, field.selected]));
      this.selectedFields = this.defaultFields.map(defaultField => ({
        ...defaultField,
        selected: storedFieldMap.has(defaultField.key) ? storedFieldMap.get(defaultField.key) : defaultField.selected
      }));
    } else {
      this.selectedFields = [...this.defaultFields];
    }

    const historySelection = localStorage.getItem('readyProductHistorySelected');
    if (historySelection) {
      const storedFields = JSON.parse(historySelection);
      const storedFieldMap = new Map(storedFields.map((field: any) => [field.key, field.selected]));
      this.historySelectedFields = this.historyDefaultFields.map(defaultField => ({
        ...defaultField,
        selected: storedFieldMap.has(defaultField.key) ? storedFieldMap.get(defaultField.key) : defaultField.selected
      }));
    } else {
      this.historySelectedFields = [...this.historyDefaultFields];
    }
  }

  saveSelectedFields() {
    if (this.activeTab === 'current') {
      localStorage.setItem('readyProductSelected', JSON.stringify(this.selectedFields));
    } else {
      localStorage.setItem('readyProductHistorySelected', JSON.stringify(this.historySelectedFields));
    }
  }

  getReadyProductList() {
    let params = new HttpParams().set('ready-product-type', 'lot-wise');
    this.readyProductService.getReadyProducts(params).subscribe(
      (response: any) => {
        if (response?.data?.length) {
          console.log('Fetched ready products:', response.data);
          this.readyProductList = response.data.reverse();
          this.filterTable(); // Apply filters and pagination after fetching data
        } else {
          this.readyProductList = [];
          this.paginatedStockList = [];
          this.totalPages = 0;
        }
      },
      (error: any) => {
        this.notificationService.showError(
          'Failed to fetch ready products.',
          'Error'
        );
        this.readyProductList = [];
        this.paginatedStockList = [];
        this.totalPages = 0;
      }
    );
  }

  getLotAdditionHistory() {
    let params = new HttpParams()
      .set('stin_product_code_type', 'ready product')
      .set('stin_product_type', 'lot-wise')
      .set('stin_distribution', 'wholesale'); // lot-wise distribution

    this.stockInService.getStockInEntries(params).subscribe({
      next: (response: any) => {
        if (response?.data?.length) {
          this.stockInHistoryList = response.data.reverse();
          this.filterTable();
        } else {
          this.stockInHistoryList = [];
          this.paginatedHistoryList = [];
        }
      },
      error: (err: any) => {
        this.notificationService.showError('Failed to fetch lot addition history.', 'Error');
        this.stockInHistoryList = [];
        this.paginatedHistoryList = [];
      }
    });
  }

  deleteReadyProduct(id: any): void {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this ready product?'
    );
    if (confirmDelete) {
      this.readyProductService.deleteReadyProduct(id).subscribe(
        (response: any) => {
          this.notificationService.showSuccess(
            'Ready product deleted successfully!',
            'Success'
          );
          this.getReadyProductList(); // Re-fetch and re-filter
        },
        (error: any) => {
          this.notificationService.showError(
            'Failed to delete ready product. Please try again.',
            'Error'
          );
        }
      );
    }
  }

  editReadyProduct(id: any) {
    // Implement navigation or modal for editing, similar to StoneStockComponent if needed
  }


  filterTable() {
    const dataList = this.activeTab === 'current' ? this.readyProductList : this.stockInHistoryList;
    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    const dateKey = this.activeTab === 'current' ? 'rproduct_date' : 'stin_entry_date';

    if (!dataList) return;

    let filtered = dataList.filter((item: any) => {
      /* ================= PRODUCT TYPE FILTER ================= */
      if (this.activeTab === 'current' && this.selectedProductType !== 'all' && item.rproduct_type !== this.selectedProductType) {
        return false;
      }

      if (this.activeTab === 'history' && item.stin_product_type !== 'lot-wise') {
        return false;
      }

      /* ================= DATE FILTER ================= */
      if (this.startDate || this.endDate) {
        const itemDateRaw = item[dateKey];
        if (!itemDateRaw) return false;
        const itemDate = new Date(itemDateRaw).setHours(0, 0, 0, 0);
        const start = this.startDate ? new Date(this.startDate).setHours(0, 0, 0, 0) : null;
        const end = this.endDate ? new Date(this.endDate).setHours(0, 0, 0, 0) : null;
        if (start && itemDate < start) return false;
        if (end && itemDate > end) return false;
      }

      /* ================= COLUMN FILTER ================= */
      const matchesFieldFilters = fields.every((field) => {
        if (!field.selected) return true;
        const searchTerm = (this.searchValues[field.key] || '').trim().toLowerCase();
        if (!searchTerm) return true;
        const fieldValue = (item[field.key] ?? '').toString().toLowerCase();
        return fieldValue.includes(searchTerm);
      });

      /* ================= GLOBAL SEARCH ================= */
      const matchesGlobalSearch = this.globalSearchText
        ? Object.values(item).some((val) => (val ?? '').toString().toLowerCase().includes(this.globalSearchText.trim().toLowerCase()))
        : true;

      return matchesFieldFilters && matchesGlobalSearch;
    });

    /* ================= SORT ================= */
    if (this.sortKey) {
      filtered.sort((a: any, b: any) => {
        const valA = a[this.sortKey] ?? '';
        const valB = b[this.sortKey] ?? '';
        return this.sortDirection === 'asc' ? (valA > valB ? 1 : valA < valB ? -1 : 0) : (valA < valB ? 1 : valA > valB ? -1 : 0);
      });
    }

    /* ================= SAVE FILTERED ================= */
    if (this.activeTab === 'current') {
      this.filteredReadyProductList = filtered;
      this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
      this.currentPage = Math.min(this.currentPage, this.totalPages || 1);
      const start = (this.currentPage - 1) * this.itemsPerPage;
      this.paginatedStockList = filtered.slice(start, start + this.itemsPerPage);
    } else {
      this.filteredHistoryList = filtered;
      this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
      this.currentPage = Math.min(this.currentPage, this.totalPages || 1);
      const start = (this.currentPage - 1) * this.itemsPerPage;
      this.paginatedHistoryList = filtered.slice(start, start + this.itemsPerPage);
    }
  }



  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.filterTable();
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.filterTable(); // Re-apply filter to update pagination
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterTable();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterTable();
    }
  }

  get pageNumbers(): number[] {
    const pageNumbers: number[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);

      // Show ellipsis if current page is far from the start
      if (this.currentPage > 2) {
        pageNumbers.push(-1); // Sentinel for '...'
      }

      // Determine range of pages around current page
      let start = Math.max(2, this.currentPage - Math.floor(maxPagesToShow / 2) + 1);
      let end = Math.min(this.totalPages - 1, this.currentPage + Math.floor(maxPagesToShow / 2) - 1);

      // Adjust range if current page is near start or end
      if (this.currentPage <= Math.floor(maxPagesToShow / 2) + 1) {
        end = Math.min(this.totalPages - 1, maxPagesToShow - 1);
      }
      if (this.currentPage >= this.totalPages - Math.floor(maxPagesToShow / 2)) {
        start = Math.max(2, this.totalPages - maxPagesToShow + 2);
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      // Show ellipsis if current page is far from the end
      if (this.currentPage < this.totalPages - 1) {
        if (pageNumbers[pageNumbers.length - 1] !== this.totalPages && pageNumbers[pageNumbers.length - 1] !== -1) {
          pageNumbers.push(-1); // Sentinel for '...'
        }
      }

      // Always show last page if not already in the visible range
      if (!pageNumbers.includes(this.totalPages) && this.totalPages > 1) {
        pageNumbers.push(this.totalPages);
      }
    }

    // Filter out duplicate -1 (ellipsis) and ensure page numbers are unique and sorted
    const uniquePageNumbers = Array.from(new Set(pageNumbers)).sort((a, b) => a - b);
    return uniquePageNumbers;
  }


  selectAllFields() {
    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    fields.forEach((field) => (field.selected = true));
    this.saveSelectedFields();
    this.filterTable();
  }

  deselectAllFields() {
    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    fields.forEach((field) => (field.selected = false));
    this.saveSelectedFields();
    this.filterTable();
  }

  get selectedFieldss() {
    return this.selectedFields.filter((field) => field.selected);
  }

  applyColumnSelection() {
    this.saveSelectedFields();
    this.showDropdown = false;
    this.filterTable(); // Re-apply filter to update the table display
  }

  downloadPDF(): void {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a3',
    });

    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    const selectedFields = fields.filter(f => f.selected);

    if (!selectedFields.length) {
      this.notificationService.showError('Please select at least one column', 'Error');
      return;
    }

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    /* ================= HEADER ================= */

    const reportTitle = this.activeTab === 'current' ? 'Ready Product Report' : 'Lot Addition History Report';
    doc.text(reportTitle, pageWidth / 2, 16, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(
      `Generated on: ${new Date().toLocaleString()}`,
      pageWidth - 15,
      10,
      { align: 'right' }
    );

    /* ================= TABLE ================= */

    const headers = [
      { header: 'No.', dataKey: 'no' },
      ...selectedFields.map(f => ({
        header: f.label,
        dataKey: f.key,
      })),
    ];

    const sourceData = this.getExportSourceData();

    const body = sourceData.map((item, index) => {

      const row: any = { no: index + 1 };

      selectedFields.forEach(f => {
        row[f.key] = this.getDisplayValue(item[f.key]);
      });

      return row;
    });

    autoTable(doc, {
      columns: headers,
      body,

      startY: 24,

      margin: { left: 6, right: 6 },

      theme: 'grid',

      horizontalPageBreak: false,   // 🔥 stop sideways splitting
      rowPageBreak: 'auto',

      // 🔥 force fit to page width
      tableWidth: pageWidth - 12,

      styles: {
        fontSize: 6.2,
        cellPadding: 1.3,
        overflow: 'linebreak',
        valign: 'middle',
      },

      headStyles: {
        fillColor: [193, 151, 37],
        textColor: 255,
        halign: 'center',
        fontSize: 7,
        fontStyle: 'bold',
      },

      columnStyles: {
        no: { cellWidth: 12, halign: 'center' },
      },

      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: () => {
        doc.setFontSize(8);
        doc.text(
          `Page ${(doc as any).getNumberOfPages()}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        );
      },
    });

    const fileName = this.activeTab === 'current' ? 'ready-product-report.pdf' : 'lot-addition-history-report.pdf';
    doc.save(fileName);
  }



  downloadExcel(): void {
    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    const selectedFields = fields.filter((field) => field.selected);

    // ✅ numeric columns (backend keys)
    const numericKeys = [
      'rproduct_silver_rate_per_gm',
      'rproduct_cny_labour',
      'rproduct_per_gram_labour',
      'rproduct_shipping_per_gm',
      'rproduct_other_expense_per_gm',
      'rproduct_packaging_cost',
      'rproduct_per_gm_cost_without_packaging',
      'rproduct_quantity',
      'rproduct_total_wt',
      'rproduct_carat',
      'rproduct_per_carat_price',
      'rproduct_total_carat_price',
      'rproduct_stone_price',
      'stin_total_wt',
      'stin_panni_wt',
      'stin_net_weight'
    ];

    const sourceData = this.getExportSourceData();

    const data = sourceData.map((item, index) => {

      const row: any = { 'No.': index + 1 };

      selectedFields.forEach((field) => {
        let value: any = item[field.key];

        // ✅ force numeric
        if (numericKeys.includes(field.key)) {
          value =
            value !== null &&
              value !== undefined &&
              value !== ''
              ? Number(value)
              : 0;
        }

        row[field.label] = value;
      });

      return row;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // ✅ force numeric cell types
    Object.keys(worksheet).forEach((cell) => {
      if (cell.startsWith('!')) return;

      const c = worksheet[cell];
      if (typeof c.v === 'number') {
        c.t = 'n';
      }
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Ready Product List': worksheet },
      SheetNames: ['Ready Product List'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const fileName = this.activeTab === 'current' ? 'ready-product-lot-list.xlsx' : 'lot-addition-history.xlsx';
    FileSaver.saveAs(
      new Blob([excelBuffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
      fileName
    );
  }


  downloadJSONAll(): void {
    const data = this.getExportSourceData();

    const jsonString = JSON.stringify(data, null, 2);

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = this.activeTab === 'current' ? 'ready-product-lot-list.json' : 'lot-addition-history.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href);
  }

  downloadCSV(): void {
    const data = this.getExportSourceData();

    if (!data.length) return;

    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    const selectedFields = fields?.filter((f) => f.selected) || [];
    const headers = ['No.', ...selectedFields.map((f) => f.label)];
    const keys = selectedFields.map((f) => f.key);

    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...keys.map((key) => {
          const value = this.getDisplayValue(item[key]);
          return typeof value === 'string' && value.includes(',')
            ? `"${value}"`
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = this.activeTab === 'current' ? 'ready-product-lot-list.csv' : 'lot-addition-history.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href);
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  restoreColumnSelection() {
    if (this.activeTab === 'current') {
      localStorage.removeItem('readyProductSelected');
      this.selectedFields = [...this.defaultFields];
    } else {
      localStorage.removeItem('readyProductHistorySelected');
      this.historySelectedFields = [...this.historyDefaultFields];
    }
    this.filterTable();
  }

  printTable() {
    const title = this.activeTab === 'current' ? 'Ready Product(Lot) List' : 'Lot Addition History';

    let printContent = `
    <html>
    <head>
      <title>${title}</title>
      <style>
        body { font-family: Arial, sans-serif; }
        table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 12px; }
        th, td { border-right: 2px solid #000; border-bottom: 2px solid #000; padding: 8px; text-align: left; vertical-align: middle; white-space: nowrap; }
        th:first-child, td:first-child { border-left: 2px solid #000; }
        thead th { border-top: 2px solid #000; background-color: #f2f2f2; font-weight: 600; }
        tbody tr:last-child td { border-bottom: 2px solid #000; }
        @media print {
          @page { size: auto; margin: 8mm; }
          body { margin: 0; }
          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <h3>${title}</h3>
      <table>
        <thead>
          <tr>
            <th>No.</th>
    `;

    const fields = this.activeTab === 'current' ? this.selectedFields : this.historySelectedFields;
    fields.forEach(field => {
      if (field.selected) {
        printContent += `<th>${field.label}</th>`;
      }
    });

    printContent += `
          </tr>
        </thead>
        <tbody>
    `;

    const data = this.getExportSourceData();
    data.forEach((item, index) => {
      printContent += `
        <tr>
          <td>${(this.currentPage - 1) * this.itemsPerPage + index + 1}</td>
      `;
      fields.forEach(field => {
        if (field.selected) {
          printContent += `<td>${this.getDisplayValue(item[field.key])}</td>`;
        }
      });
      printContent += `</tr>`;
    });

    printContent += `
        </tbody>
      </table>
    </body>
    </html>
    `;

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    }
  }

  onFieldToggle(field: any) {
    // The [(ngModel)] handles the field.selected change directly.
    // We just need to save the state and re-filter.
    this.saveSelectedFields();
    this.filterTable();
  }

  // Removed the 'subKey' parameter since it's not needed for any fields in ReadyProductList
  getDisplayValue(value: any): string {
    if (value === null || value === undefined) return "";

    // If array → join values
    if (Array.isArray(value)) {
      return value
        .map(v => this.getDisplayValue(v))
        .join(", ");
    }

    // If object → extract useful fields
    if (typeof value === "object") {

      // Priority: show name if exists
      if (value.name) return value.name;

      // Show label if exists
      if (value.label) return value.label;

      // Show title if exists
      if (value.title) return value.title;

      // Show Type + Name (your category format)
      if (value.Type && value.name) {
        return `${value.name}`;
        // or `${value.name} (${value.Type})`
      }

      // Fallback → join values
      return Object.values(value).join(", ");
    }

    return String(value);
  }


  ngOnDestroy(): void {
    if (this.firmSubscription) {
      this.firmSubscription.unsubscribe();
    }
  }
  private getExportSourceData() {
    if (this.activeTab === 'current') {
      return this.filteredReadyProductList;
    } else {
      return this.filteredHistoryList;
    }
  }

  switchTab(tab: 'current' | 'history') {
    this.activeTab = tab;
    this.searchValues = {};
    this.globalSearchText = '';
    this.startDate = '';
    this.endDate = '';
    this.sortKey = '';
    this.currentPage = 1;
    this.filterTable();
  }

}
